import { useNavigate } from "react-router-dom";
import { BaSeButton } from "@base/react";
import { useState, useMemo, useRef, useEffect } from "react";
import logoHeader from "../../assets/images/logo-planejadora.svg";
import TutorialGuarantees from "./steps/guarantees";
import TutorialInventoryTurnOver from "./steps/inventory-turnover";
import TutorialMonthlyAverage from "./steps/monthly-average";
import TutorialNamePlanning from "./steps/name-planning";
import TutorialPaymentTerms from "./steps/payment-terms";
import TutorialProjectedCashFlow from "./steps/projected-cash-flow";
import TutorialReceiptDeadline from "./steps/receipt-deadline";
import TutorialResults from "./steps/results";
import TutorialTotalInvestment from "./steps/total-investment";
import TutorialVariableIndirectCosts from "./steps/variable-indirect-costs";

const PlanningTutorial = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isExpanded, setIsExpanded] = useState(false);
  const touchStartY = useRef(0);
  const touchEndY = useRef(0);
  const navigate = useNavigate();

  const handleTouchEnd = () => {
    const deltaY = touchEndY.current - touchStartY.current;
    if (deltaY > 30) {
      setIsExpanded(true);
    } else if (deltaY < -30) {
      setIsExpanded(false);
    }
  };

  useEffect(() => {
    const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};

    if (tutorials.isFinished) {
      navigate("/planejadora-sebrae");
    }
  }, [navigate]);

  const steps = useMemo(
    () => [
      {
        index: 1,
        title: "Novo Planejamento",
        content: <TutorialNamePlanning />,
      },
      { index: 2, title: "Média Mensal", content: <TutorialMonthlyAverage /> },
      {
        index: 3,
        title: "Custos Indiretos Variáveis",
        content: <TutorialVariableIndirectCosts />,
      },
      {
        index: 4,
        title: "Investimento Total",
        content: <TutorialTotalInvestment />,
      },
      {
        index: 5,
        title: "Prazos de Recebimento",
        content: <TutorialReceiptDeadline />,
      },
      {
        index: 6,
        title: "Prazos de Pagamento",
        content: <TutorialPaymentTerms />,
      },
      {
        index: 7,
        title: "Giro de Estoque",
        content: <TutorialInventoryTurnOver />,
      },
      {
        index: 8,
        title: "Resultados",
        content: <TutorialResults />,
      },
      {
        index: 9,
        title: "Fluxo de Caixa Projetado",
        content: <TutorialProjectedCashFlow />,
      },
      { index: 10, title: "Garantias", content: <TutorialGuarantees /> },
    ],
    []
  );

  const goNextStep = () => {
    if (currentStep < steps.length) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };

  const goPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };

  const currentStepData = steps.find((step) => step.index === currentStep);

  return (
    <div className="planning">
      <div className="steps">
        <div
          className={"steps__header" + (isExpanded ? " expanded" : "")}
          onTouchEnd={handleTouchEnd}
        >
          <div className="content_header">
            <ul>
              {steps.map((step) => {
                const active = step.index === currentStep ? "active" : "";
                const hasName =
                  step.index === 1 && currentStep > 1 ? "has-name" : "";
                return (
                  <li key={step.index} className={`${active} ${hasName}`}>
                    <p>{step.title}</p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="steps__body">
          <div className="container">
            <img src={logoHeader} className="new-logo" alt="logo" />
          </div>

          <div className="container">
            {currentStepData?.content}

            <div
              className="planning__footer"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div id="botaoVoltarTutorial">
                {currentStep > 1 && (
                  <BaSeButton
                    size="medium"
                    value="Voltar"
                    width="87px"
                    onClick={goPreviousStep}
                  />
                )}
              </div>

              <div id="botaoSeguirTutorial">
                {currentStep < steps.length && (
                  <BaSeButton
                    buttonType="submit"
                    size="medium"
                    value="Próximo"
                    width="87px"
                    onClick={goNextStep}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanningTutorial;
